<script setup lang="ts">
import ScPage from '@/components/common/page/ScPage.vue';
import { user } from '@/models/User';
import dayjs from 'dayjs';
import { computed, onMounted, reactive, ref } from 'vue';
import ScBtn from '@/components/common/widget/ScBtn.vue';
import { message, Modal } from 'ant-design-vue';
import { request } from '@/util/request';
import { tokenManager } from '@/util/token';
import { useRouter } from 'vue-router';

const isVip = computed(
  () => user.data.user?.vipExpired && user.data.user.vipExpired > Date.now()
);
const activeKey = ref('changePassword');
const tabList = [
  {
    key: 'changePassword',
    tab: '修改密码',
  },
  {
    key: 'useCode',
    tab: '使用兑换码',
  },
];

const changePasswordForm = reactive({
  old: '',
  new: '',
  confirm: '',
});

async function changePassword() {
  if (changePasswordForm.new != changePasswordForm.confirm) {
    message.error('确认密码与新密码不一致');
    return;
  }
  const res = await request(
    '/management/user/changePassword',
    changePasswordForm
  );
  if (res) {
    Object.assign(changePasswordForm, {
      old: '',
      new: '',
      confirm: '',
    });
    message.success('修改成功');
  }
}

const codeForm = reactive({
  code: '',
});

async function useCode() {
  const res = await request('/management/user/useCode', codeForm);
  if (res) {
    console.log(res);
    user.set(res);
    Object.assign(codeForm, {
      code: '',
    });
    message.success('兑换成功成功');
  }
}

const setting = ref();
onMounted(async () => {
  const res = await request('/management/setting/get', { key: 'app' });
  if (res) {
    setting.value = res.value;
  }
});

const products = ref();
onMounted(async () => {
  const res = await request('/management/product/list');
  if (res) {
    products.value = res.list;
  }
});

const router = useRouter();

async function logout() {
  const confirm = await new Promise((resolve) => {
    Modal.confirm({
      title: '确定要退出登录吗',
      onOk: () => resolve(true),
      onCancel: () => resolve(false),
    });
  });
  if (!confirm) {
    return;
  }
  const res = await request('/management/login/logout', null, {
    noNeedLogin: true,
  });
  if (res) {
    tokenManager.del();
    user.del();
    await router.push('/login');
  }
}
</script>

<template>
  <sc-page title="个人中心" v-if="user.data.user">
    <div style="display: flex; flex-direction: row; width: 100%; padding: 20px">
      <a-card title="个人信息" style="width: 400px; margin-right: 20px">
        <div class="line space-between">
          <div>用户名</div>
          <div>{{ user.data.user.username }}</div>
        </div>
        <div class="line space-between">
          <div>联系邮箱</div>
          <div>{{ user.data.user.email }}</div>
        </div>
        <div class="line space-between">
          <div>注册时间</div>
          <div>
            {{
              dayjs(Number(user.data.user.createTime)).format(
                'YYYY-MM-DD HH:mm:ss'
              )
            }}
          </div>
        </div>
        <div class="line space-between">
          <div>账号等级</div>
          <div v-if="isVip">VIP用户</div>
          <div v-else>普通用户</div>
        </div>
        <div v-if="isVip" class="line space-between">
          <div>到期时间</div>
          <div>
            {{
              dayjs(Number(user.data.user.vipExpired)).format(
                'YYYY-MM-DD HH:mm:ss'
              )
            }}
          </div>
        </div>
        <div class="line" style="text-align: right">
          <sc-btn type="primary" text="退出登录" :handler="() => logout()" />
        </div>
      </a-card>
      <a-card
        style="flex-grow: 1"
        :tab-list="tabList"
        :active-tab-key="activeKey"
        @tab-change="(key: string) => (activeKey = key)"
      >
        <div v-if="activeKey === 'changePassword'" style="max-width: 300px">
          <div style="margin-bottom: 16px">
            <a-input-password
              v-model:value="changePasswordForm.old"
              placeholder="请输入原密码"
            />
          </div>
          <div style="margin-bottom: 16px">
            <a-input-password
              v-model:value="changePasswordForm.new"
              placeholder="请输入新密码"
            />
          </div>
          <div class="line">
            <a-input-password
              v-model:value="changePasswordForm.confirm"
              placeholder="请确认新密码"
            />
          </div>
          <sc-btn
            :handler="changePassword"
            type="primary"
            text="确定"
            style="margin-top: 16px"
          />
        </div>
        <div v-if="activeKey === 'useCode'" style="max-width: 300px">
          <div style="margin-bottom: 16px">
            <a-input v-model:value="codeForm.code" placeholder="请输入兑换码" />
          </div>
          <sc-btn
            :handler="useCode"
            type="primary"
            text="确定"
            style="margin-top: 16px"
          />
        </div>
      </a-card>
    </div>
  </sc-page>
</template>

<style scoped lang="scss">
.space-between {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.line {
  margin-bottom: 10px;

  &:last-child {
    margin-bottom: 0;
  }
}

.desc {
}
</style>
